import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Firearms() {
  useDocumentMeta('Firearms Store in Lake Benton, Minnesota | Kjergaard Sports', 'Browse approximately 5,000 new and used firearms on hand at Kjergaard Sports in Lake Benton, Minnesota. Options for hunting, sport shooting, CCW, and collectors.');
  const categories = ['Hunting firearms', 'Sport shooting', 'CCW customers', 'Collectors', 'Trap and skeet', 'Waterfowl', 'Upland', 'Varmints', 'Big game', 'Shotguns, rifles, handguns, and more'];
  return <div data-id="element-257">
      <PageHero title="Firearms Store in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/h2HHsk76CJxRY2pmsyL8mj/firearms-wall.jpg" alt="Firearms selection at Kjergaard Sports" data-id="element-258" />

      <section className="py-20 bg-brand-offwhite" data-id="element-259">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-261">
            <div data-id="element-262">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-263">
                Approximately 5,000 Guns on Hand
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-264">
                Kjergaard Sports is known across the region for our sheer volume
                and variety of firearms. We carry an enormous selection of new
                and used guns, ensuring that whether you are a first-time buyer
                or a seasoned collector, you'll find options worth exploring.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-265">
                Our primary audience is hunters, but our inventory is deep
                enough to serve sport shooters, personal defense customers, and
                specialized competitors.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-266">
                <h3 className="font-serif text-xl mb-4" data-id="element-267">
                  Our Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-268">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-269">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-270" />
                      <span className="text-brand-charcoal/90" data-id="element-271">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-272">
                <a href="tel:507-368-4696" className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium text-center transition-colors flex items-center justify-center" data-id="element-273">
                  <Phone className="w-5 h-5 mr-2" data-id="element-274" />
                  Call the Store
                </a>
                <Link to="/contact" className="border-2 border-brand-charcoal/20 hover:border-brand-leather text-brand-charcoal px-8 py-4 rounded-sm font-medium text-center transition-colors flex items-center justify-center" data-id="element-275">
                  <MapPin className="w-5 h-5 mr-2" data-id="element-276" />
                  Plan Your Visit
                </Link>
              </div>
            </div>

            <div data-id="element-277">
              <img src="https://cdn.magicpatterns.com/uploads/1WmymfCRjNVxeWfAjjuCCR/firearms-cases.jpg" alt="Firearms display cases at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-278" />
            </div>
          </div>
        </div>
      </section>
    </div>;
}